import { connect } from 'react-redux';
import { getLoginPathFromState } from '../Helpers/utils';

// The previous authenticatedSelector always returned true; retain that policy.
// Session and permission checks remain in the existing application/backend flows.
// This removes redux-auth-wrapper's unmaintained query-string dependency.
const privateRoute = Component => connect(state => ({
  redirectPath: getLoginPathFromState(state),
  isAuthenticated: true,
  isAuthenticating: false,
}))(Component);

export default privateRoute;
